import React from 'react';
import PropTypes from 'prop-types';

const More = ({ fill }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    enableBackground="new 0 0 512 512">
    <g>
      <path
        fill={fill}
        d="M60.952,195.048C27.343,195.048,0,222.391,0,256s27.343,60.952,60.952,60.952
        s60.952-27.343,60.952-60.952S94.562,195.048,60.952,195.048z"
      />
      <path
        fill={fill}
        d="M256,195.048c-33.609,0-60.952,27.343-60.952,60.952s27.343,60.952,60.952,60.952
        s60.952-27.343,60.952-60.952S289.609,195.048,256,195.048z"
      />
      <path
        fill={fill}
        d="M451.048,195.048c-33.609,0-60.952,27.343-60.952,60.952s27.343,60.952,60.952,60.952
        S512,289.609,512,256S484.657,195.048,451.048,195.048z"
      />
    </g>
  </svg>
);

More.propTypes = {
  fill: PropTypes.string,
};

More.defaultProps = {
  fill: undefined,
};

export default More;



// WEBPACK FOOTER //
// ./src/images/svg_js/More.js